import { Component, type ErrorInfo, type ReactNode } from 'react';
import { triggerGuardedClientReload } from '../../../services/clientVersion';
import { classifyAssetLoadFailure } from '../../../utils/assetLoadFailure';
import AssetLoadErrorView from './AssetLoadErrorView';

interface AssetLoadErrorBoundaryProps {
  children: ReactNode;
}

interface AssetLoadErrorBoundaryState {
  error: unknown;
}

class AssetLoadErrorBoundary extends Component<
  AssetLoadErrorBoundaryProps,
  AssetLoadErrorBoundaryState
> {
  state: AssetLoadErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: unknown): AssetLoadErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, _errorInfo: ErrorInfo): void {
    if (classifyAssetLoadFailure(error)) {
      triggerGuardedClientReload();
    }
  }

  render(): ReactNode {
    const { error } = this.state;

    if (error === null) {
      return this.props.children;
    }

    if (classifyAssetLoadFailure(error)) {
      return (
        <div id="error-page" className="error-page">
          <AssetLoadErrorView />
        </div>
      );
    }

    throw error;
  }
}

export default AssetLoadErrorBoundary;
